<template>
  <div class="wrapper">
    <div>
      <span>DATOS DE NAVIXY</span>
      <span id="total">Total: {{ count }}</span>
    </div>

    <br />

    <div class="table-container">
      <el-table :data="Data" style="width: 100%" class="Tabla" height="400">
        <el-table-column label="ID" prop="ID" minWidth:150> </el-table-column>

        <el-table-column
          prop="Name"
          label="Descripcion"
          minWidth:150
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Cliente: String
  },

  data() {
    return {
      isLoading: false,
      NavUsers: [],
      trackers: [],
      Data: [],
      count: 0
    };
  },

  methods: {
    getData() {
      this.NavUsers.push(this.$store.getters["navixy/getUserList"]);
      this.trackers.push(this.$store.getters["navixy/getTrackers"]);
    },

    findUser(value) {
      this.Data = [];
      this.isLoading = true;
      const user = this.NavUsers[0].find(
        ({ post_region }) => post_region === value
      );

      if (user) {
        let values = this.trackers[0].filter(
          ({ user_id }) => user_id == user.id
        );
        values.forEach(({ id, label }) => {
          this.Data.push({
            ID: id,
            Name: label
          });
        });
        this.count = this.Data.length;
        this.$emit("GPSDATA", this.Data);
      } else {
        this.count = 0;
      }
      this.isLoading = false;
    }
  },

  watch: {
    Cliente() {
      if (this.Cliente != "") {
        this.getData();
        this.findUser(this.Cliente);
      } else {
        this.Data = [];
      }
    }
  }
};
</script>

<style>
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Tabla {
  margin: 0 auto;
  /* padding-left: 200px; */
}
.table-container {
  margin: 0 auto;
}
#total {
  float: right;
}
</style>
